/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Edit_DescriptionInputs */

const en_admin_categories_edit_description = /** @type {(inputs: Admin_Categories_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update category details`)
};

/**
* | output |
* | --- |
* | "Update category details" |
*
* @param {Admin_Categories_Edit_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_categories_edit_description = /** @type {((inputs?: Admin_Categories_Edit_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Edit_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_categories_edit_description(inputs)
});
export { admin_categories_edit_description as "admin.categories.edit_description" }